import React from 'react';
import { useEffect, useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import Topbar from './scenes/global/Topbar'
import Sidebar from './scenes/global/Sidebar'
import Dashboard from './scenes/dashboard'
import Team from './scenes/team'
import Owners from './scenes/owners'
import AddUser from './scenes/add-user'
import DelUser from './scenes/del-user'
import Devices from './scenes/devices'
import SetOwnerDevice from './scenes/set-owner-device'
import NotificationClients from './scenes/notification-clients'
import Profile from './scenes/profile'
import EditUser from './scenes/edit'
import Device from './scenes/device'
import Events from './scenes/events'

// Owners page
import AddOwner from './scenes/add-owner'
import DelOwner from './scenes/del-owner'
import SetOwner from './scenes/set-owner'
import EditOwner from './scenes/edit-owner'

// Whitelist page
import Whitelist from './scenes/whitelist'
import AddWhitelist from './scenes/add-whitelist'
import DelWhitelist from './scenes/del-whitelist'

// Livestreams page
import Livestreams from './scenes/livestreams'
import EditLivestream from './scenes/edit-livestream'
import AddLivestream from './scenes/add-livestream'
import DelLivestream from './scenes/del-livestream'
import WorldView from './scenes/worldview'

import { CssBaseline, ThemeProvider } from '@mui/material'
import { ColorModeContext, useMode } from './theme'

import * as Constants from './constants'

import Login from './components/Login/Login'

import useToken from './useToken'

function App() {
  const [theme, colorMode] = useMode()
  const [isSidebar, setIsSidebar] = useState(true)
  const { token, setToken } = useToken()
  const [validated, setValidated] = useState(true)

  useEffect(() => {
    if (token === null || token === undefined) {
      setValidated(false)
    } else {
      try {
        fetch(Constants.HOST + '/validateToken', {
          headers: { 'Content-Type': 'application/json' },
          method: 'POST',
          body: JSON.stringify({
            token: JSON.parse(localStorage.getItem('user_data')).token,
            username: JSON.parse(localStorage.getItem('user_data')).username,
          }),
        }).then((data) =>
          data.json().then((data) => {
            setValidated(data.valid)
          })
        )
      } catch (error) {
        console.error(error)
        return false
      }
    }
  })

  if (!token || token === null || token === undefined || !validated) {
    return <Login setToken={setToken} />
  }

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <Sidebar isSidebar={isSidebar} />
          <main className="content">
            <Topbar setIsSidebar={setIsSidebar} />
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/team" element={<Team />} />
              <Route path="/owners" element={<Owners />} />
              <Route path="/edit/:id" element={<EditUser />} />
              <Route path="/edit-owner/:id" element={<EditOwner />} />
              <Route path="/device/:id" element={<Device />} />
              <Route path="/set-owner/:ids" element={<SetOwner />} />
              <Route path="/set-owner-device/:ids" element={<SetOwnerDevice />} />
              <Route path="/add-user" element={<AddUser />} />
              <Route path="/add-owner" element={<AddOwner />} />
              <Route path="/del-user/:id" element={<DelUser />} />
              <Route path="/del-owner/:id" element={<DelOwner />} />
              <Route path="/add-whitelist" element={<AddWhitelist />} />
              <Route path="/del-whitelist/:id" element={<DelWhitelist />} />
              <Route path="/devices" element={<Devices />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/events" element={<Events />} />
              <Route path="/whitelist" element={<Whitelist />} />
              <Route path="/livestreams" element={<Livestreams />} />
              <Route path="/add-livestream" element={<AddLivestream />} />
              <Route path="/edit-livestream/:id" element={<EditLivestream />} />
              <Route path="/del-livestream/:id" element={<DelLivestream />} />
	  		  <Route path="/notification-clients" element={<NotificationClients />} />
	  		  <Route path="/worldview" element={<WorldView/>} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  )
}

export default App
